import React from "react";
import {
  Button,
  Divider,
  InfoTimeCardAdv,
  NewTable,
  PageHeader,
  PageTitle,
} from "../../../../../../components";

const ResignationDetails = () => {
  return (
    <div>
      <div className="flex gap-8 mb-6 ">
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Offboarding ID"
            value="EX2022-20"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Date of Release"
            value="11/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Notice Due"
            value="10/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Exit Type"
            value="Resignation"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Status"
            value="Released"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
      </div>

      <PageHeader
        Section={
          <div className="flex">
            <PageTitle
              title={"RESIGNATION DETAILS"}
              icon={"business_center"}
              tag="p"
            />
          </div>
        }
        RightSection={
          <>
            <Button title="Send Notification" size="sm" />
          </>
        }
      />

      <Divider className="mt-1" />
      <div className="mt-3 border-[1px] border-neutrals-100 p-4 rounded-md items-center text-center">
        <p className="body-two mb-4">No Resignation Details Found</p>
        <p className="body-two">
          Employee Onboarding is initiated by Richa Sarkar
        </p>
      </div>

      <p className="body-two mt-24">
        Last updated on 01/12/2022 at 17:41:13 by Richa Sarkar.{" "}
        <span className="text-info cursor-pointer">View All Activities</span>
      </p>
    </div>
  );
};

export default ResignationDetails;
